(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-floating-product"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pp-floating-product')) {
  customElements.define('pp-floating-product', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      const pause = this.querySelector('.pp-float__pause');
      const slider = this.querySelector('input');
      const stage = this.querySelector('.pp-float__stage');
      const media = matchMedia('(prefers-reduced-motion: reduce)');
      const setPaused = (value) => {
        this.toggleAttribute('data-paused', value);
        pause.setAttribute('aria-pressed', String(value));
        pause.textContent = value ? pause.dataset.play : pause.dataset.pause;
      };
      setPaused(media.matches);
      pause.addEventListener('click', () => setPaused(!this.hasAttribute('data-paused')));
      slider.addEventListener('input', () => {
        this.style.setProperty('--pp-turn', `${slider.value}deg`);
      });
      stage.addEventListener('pointermove', (event) => {
        if (event.pointerType !== 'mouse' || media.matches) return;
        const box = stage.getBoundingClientRect();
        const turn = Math.max(-32, Math.min(32, ((event.clientX - box.left) / box.width - .5) * 64));
        this.style.setProperty('--pp-turn', `${turn}deg`);
        slider.value = String(Math.round(turn));
      });
      stage.addEventListener('pointerleave', () => {
        this.style.setProperty('--pp-turn', '0deg');
        slider.value = '0';
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
